export class Deserializer {

    public static applyDeserializedData<T extends object>(baseObject: T, deserializedData: T) {
        Object.keys(deserializedData).forEach((deserializedProperty: string) => {
            baseObject[deserializedProperty as keyof T] = deserializedData[deserializedProperty as keyof T];
        })
    }

}